import { BillingPeriod } from '@/gql/generated';

const ChargeCycleRate = {
  [BillingPeriod.Month]: 'Per Month',
  [BillingPeriod.Quarter]: 'Every Three Months',
  [BillingPeriod.HalfYear]: 'Every Six Months',
  [BillingPeriod.NineMonths]: 'Every Nine Months',
  [BillingPeriod.Year]: 'Per Year',
  [BillingPeriod.TwoYears]: 'Every Two Years',
  [BillingPeriod.ThreeYears]: 'Every Three Years',
};

/**
 * GraphQL sends the enum ('YEAR', 'TWO_YEARS'); billing-service's REST plan lists send its own
 * values ('year', 'twoYears'). Both normalize to the same key ('year', 'twoyears').
 */
export const normalizeBillingPeriod = (billingPeriod) =>
  (billingPeriod || '').toLowerCase().replace(/_/g, '');

const ChargeCycleByNormalizedPeriod = Object.fromEntries(
  Object.entries(ChargeCycleRate).map(([period, copy]) => [
    normalizeBillingPeriod(period),
    copy,
  ])
);

export const getChargeCycleForBillingPeriod = (billingPeriod) =>
  ChargeCycleByNormalizedPeriod[normalizeBillingPeriod(billingPeriod)];
